import { IAppStore } from '@/stores/typing';
import { ThemeConfigType } from '@/themes/typing';
import { isNullOrUnDef } from '@/utils/is';
import { cloneDeep } from 'lodash';
import { useMemo } from 'react';

export const useUpdatedColorPrimary = (
  colorPrimary: IAppStore['themeSettings']['colorPrimary'],
  currentTheme: ThemeConfigType | undefined,
  updatedAt: number,
) => {
  return useMemo(() => {
    if (!isNullOrUnDef(currentTheme)) {
      let newColorPrimary = cloneDeep(colorPrimary);
      if (colorPrimary.isPersist) {
        newColorPrimary.color = colorPrimary.color;
      } else {
        if (
          !isNullOrUnDef(colorPrimary.updatedAt) &&
          !isNullOrUnDef(colorPrimary.color) &&
          colorPrimary.updatedAt > updatedAt
        ) {
          newColorPrimary.color = colorPrimary.color;
        } else {
          newColorPrimary.color = currentTheme!.theme!.token!.colorPrimary;
        }
      }
      return newColorPrimary;
    }
  }, [colorPrimary, currentTheme, updatedAt]);
};
